import { UntypedFormBuilder, Validators } from "@angular/forms";
import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";

export class UploadDocumentParameters {
    public documentTypeId: number;
    public referenceId: string;
    public referenceType: number;
    public extraReferenceId?: string;
    public extraReferenceType?: number;
    public claimIdentifier?: string;
    public documentKindId?:number;
    public otherDocumentKindName:string;
    public description:string;
    public proofDocumentIds:number[];
    public validateProofDocumentsAutomatically?: boolean;
    public additionalToStoreReferenceType?: number;
    public additionalToStoreReferenceId?: string;
  }

  export class UploadDocumentParametersFormBuilder extends BaseFormBuilder {

    static getForm(fb: UntypedFormBuilder, data: UploadDocumentParameters) {
      return fb.group(
        {
          documentTypeId: [data.documentTypeId,[Validators.required,Validators.min(1)]],
          documentKindId: [data.documentKindId],
          otherDocumentKindName: [data.otherDocumentKindName],
          proofDocumentIds: [data.proofDocumentIds],
          description: [data.description],
         
        },
      );
    }

    static getFormForDescription(fb: UntypedFormBuilder, data: UploadDocumentParameters) {
      return fb.group(
        {
          description: [data.description],
         
        },
      );
    }

  }
  